import { SHOW_MENU, TOGGLE_MENU } from '../mutation-types'

const state = {
    show: false
}

const mutations = {
    [SHOW_MENU] (state, show) {
        state.show = show
    },
    [TOGGLE_MENU] (state) {
        state.show = !state.show
    }
}

export default {
    state,
    mutations
}



// WEBPACK FOOTER //
// ./src/vuex/main-menu/store.js